import { fixedHeader } from "./modules/fixedHeader";
import { lottieAnimation } from "./modules/lottieAnimation";
import { hamburgerMenu } from "./modules/hamburgerMenu";
import { cf7 } from "./modules/cf7";
import { scrollTop } from "./modules/scrollTop";
import { inview } from "./modules/inview";

document.addEventListener("DOMContentLoaded", () => {
  fixedHeader();
  lottieAnimation();
  hamburgerMenu();
  scrollTop();
  cf7();

  const rootMargin = window.matchMedia("(max-width: 767px)").matches ? "-10% 0px -10% 0px" : "-10% 0px -15% 0px";

  inview(".inview", {
    rootMargin: rootMargin,
  });
});
